import { QueryFunctionContext } from '@tanstack/react-query'
import { GET, PUT } from '../../../redux/middleware/types'
import backendRequest from '../../../services/api/backendRequest'
import driverDataEndpoints from '../api/driverDataEndpoints'
import driverDataQueryKeys from '../queries/driverDataQueryKeys'
import { DriverData, FormulaData } from '../types/driverData'

export const fetchDriverData = async (
  {
    queryKey: [{ companyId, budgetingScenarioId, periodGroups }],
    signal
  }: QueryFunctionContext<ReturnType<typeof driverDataQueryKeys.list>>,
  dimensions?: string
): Promise<DriverData[]> => {
  return backendRequest<DriverData[]>({
    method: GET,
    url: driverDataEndpoints.list(companyId),
    params: {
      budgetingScenarioId,
      periodGroups,
      dimensions
    },
    signal
  })
}

export const updateDriverData = async (
  data: FormulaData[],
  companyId: string,
  budgetingScenarioId?: number | null
): Promise<DriverData[]> => {
  return backendRequest<DriverData[]>({
    method: PUT,
    url: driverDataEndpoints.list(companyId),
    data,
    params: {
      budgetingScenarioId
    }
  })
}
